import {
  Box,
  FormControl, FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem, Radio, RadioGroup,
  Select, Switch,
  TextField,
  Tooltip, Typography
} from "@mui/material";
import React, {useContext, useState} from "react";
import {IconPlus} from "@tabler/icons-react";
import {CreateOrganization} from "../../organizations/Organizations";
import {Context as AppContext} from "../../../context/AppContext";
import {grey} from "@mui/material/colors";

export const ProjectForm = ({project, setProject, languages, organizations, asriProjects, fetchData}) => {
  const [createOrganization, setCreateOrganization] = useState(false);
  const {state: {projects}} = useContext(AppContext);

  const handleChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    updateProject(key, value);
  }

  const updateProject = (key, value) => {
    if (key) {
      setProject(prev => ({...prev, [key]: value}))
    }
  }

  return (
    <>
      <CreateOrganization
        open={createOrganization}
        handleClose={() => setCreateOrganization(false)}
        onSuccess={fetchData}
      />
      <Grid container sx={{px: {xs: 1, md: 2}, py: 0}}>
        <Grid item xs={12} sm={6} sx={{p: 1}}>
          <TextField
            name={"name"}
            label={"Project Name"}
            value={project?.name}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{shrink: true}}
          />
        </Grid>
        <Grid item xs={12} sm={6} sx={{p: 1}}>
          <FormControl fullWidth>
            <InputLabel id={`language-label`}
                        shrink={true}
                        sx={{textTransform: "capitalize"}}>Language</InputLabel>
            <Select
              labelId={`language-label`}
              id={`language-select`}
              name={"language"}
              label={"Language"}
              value={project?.language || ""}
              onChange={e => {
                const lang = languages.find(i => i.id === e.target.value);
                console.log(lang, project)
                setProject(prev => ({...prev, "language": lang?.id || null, "lang": lang?.lang || null}))
              }}
            >
              <MenuItem value={""}><em>None</em></MenuItem>
              {languages?.map(item => <MenuItem key={item?.id}
                                                value={item?.id}>{item?.language} ({item?.code})</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} sx={{p: 1, display: "flex", flexDirection: "row", gap: 1, alignItems: "center"}}>
          <FormControl fullWidth>
            <InputLabel id={`organization-label`}
                        shrink={true}
                        sx={{textTransform: "capitalize"}}>Organization</InputLabel>
            <Select
              labelId={`organization-label`}
              id={`organization-select`}
              name={"organization"}
              label={"Organization"}
              value={project?.organization || ""}
              onChange={e => {
                const org = organizations.find(i => i?.id === e.target.value);
                updateProject("organization", org?.id || null)
              }}
            >
              <MenuItem value={""}><em>None</em></MenuItem>
              {organizations?.map(item => <MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)}
            </Select>
          </FormControl>
          <Tooltip title={"Create Organization"}>
            <IconButton onClick={() => setCreateOrganization(true)}><IconPlus/></IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} sm={6} sx={{p: 1}}>
          <FormControl fullWidth>
            <InputLabel id={`asri-label`}
                        shrink={true}
                        sx={{textTransform: "capitalize"}}>ASRI</InputLabel>
            <Select
              labelId={`asri-label`}
              id={`asri-select`}
              name={"speechToText"}
              label={"ASRI"}
              value={project?.speechToText || ""}
              onChange={e => {
                console.log(e.target.value);
                const asri = asriProjects.find(i => i?.id === e.target.value);
                updateProject("speechToText", asri?.id || null)
              }}
            >
              <MenuItem value={""}><em>None</em></MenuItem>
              {asriProjects?.map(item => <MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{p: 1}}>
          <TextField
            name={"description"}
            label={"Description"}
            value={project?.description}
            fullWidth
            InputLabelProps={{shrink: true}}
            rows={3} multiline
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} sx={{p: 1}}>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Mode</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              name="mode"
              value={project?.mode || "stage"}
              onChange={e => {
                const value = e?.target?.value;
                setProject(prev => ({
                  ...prev,
                  mode: value,
                  deploymentProject: value === "production" ? null : prev?.deploymentProject || null
                }))
              }}
            >
              <FormControlLabel value="production" control={<Radio value={"production"}/>} label="Production"/>
              <FormControlLabel value="stage" control={<Radio value={"stage"}/>} label="Stage"/>
            </RadioGroup>
          </FormControl>
        </Grid>
        {
          project?.mode === "stage" &&
          <Grid item xs={12} sm={6} sx={{p: 1}}>
            <FormControl fullWidth>
              <InputLabel id={`deployment-label`}
                          shrink={true}
                          sx={{textTransform: "capitalize"}}>Deployment Project</InputLabel>
              <Select
                variant={"outlined"}
                labelId={`deployment-label`}
                id={`deployment-select`}
                name={"deploymentProject"}
                label={"Deployment Project"}
                value={project?.deploymentProject || ""}
                onChange={e => {
                  const value = e.target.value;
                  setProject(prev => ({...prev, deploymentProject: value === "" ? null : value}))
                }}
              >
                <MenuItem value={""}><em>None</em></MenuItem>
                {projects?.filter(item => item?.id !== project?.id && item?.settings?.mode === "production")?.map(item =>
                  <MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        }
        <Grid item xs={12} sm={6} sx={{p: 1}}>
          <FormControl fullWidth>
            <InputLabel id={`status-label`} shrink={true}>Status</InputLabel>
            <Select
              variant={"outlined"}
              labelId={`status-label`}
              id={`status-select`}
              name={"status"}
              label={"Status"}
              value={project?.status || ""}
              onChange={e => {
                const value = e.target.value;
                setProject(prev => ({...prev, status: value === "" ? null : value}))
              }}
            >
              <MenuItem value={""}><em>None</em></MenuItem>
              <MenuItem value={"BUILDING_SCENARIOS"}>Building Scenarios</MenuItem>
              <MenuItem value={"IN_PROGRESS"}>In Progress</MenuItem>
              <MenuItem value={"TESTING"}>Testing</MenuItem>
              <MenuItem value={"PRODUCTION"}>Production</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} sx={{p: 1}}>
          <FormControl fullWidth>
            <InputLabel id={`type`}
                        shrink={true}
                        sx={{textTransform: "capitalize"}}>Type</InputLabel>
            <Select
              labelId={`type`}
              id={`type`}
              name={"projectType"}
              value={project?.projectType || ""}
              onChange={e => {
                updateProject("projectType", e?.target?.value || null)
              }}
            >
              <MenuItem value={"VOICE_BOT"}>Voice Assistant</MenuItem>
              <MenuItem value={"CHAT_BOT"}>Chatbot Assistant</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{p: 1, pb: 0}} fontWeight={400} color={grey[600]}>Active</Typography>
          <Switch
            checked={!!project?.is_live} size={"medium"}
            onChange={(e, checked) => updateProject("is_live", checked)}
            color="secondary"
          />
          <Typography variant={"body2"} sx={{maxWidth: "sm", width: {xs: "100%", md: "80%"}, px: 1}}>Toggle between Live Mode and
            Maintenance Mode. In Maintenance Mode, calls are redirected to the configured fallback number.</Typography>
        </Grid>
      </Grid>
    </>
  )
}
